// extracted by mini-css-extract-plugin
var _1 = "TopicActivitiesPanel-module__content--fQ0Y0";
export { _1 as "content" }
